module.exports = __webpack_public_path__ + "static/media/desktoprotate.f02287b0.svg";